import type { IUserAccount, IWallet } from "../types/UserAccount.type"
import { useCurrencies } from "@/app/composables/useCurrencies"
import { computed, ref } from "vue"

const { currencies } = useCurrencies()
const user = ref<IUserAccount>()
const selectedWalletId = ref(null)

const wallets = computed<IWallet[]>(() => {
  const currencyIds = currencies.value
    .filter(currency => currency.status)
    .map(currency => currency.id)

  return user.value?.wallets.filter(wallet => currencyIds.includes(wallet.currencyId)) || []
})

const fundWallets = computed<IWallet[]>(() => {
  const fundWallets = wallets.value.filter((wallet) => {
    return wallet.type === "funds"
  })

  return fundWallets
})

const activeWallet = computed<IWallet>(() => {
  const walletId = Number.parseInt(selectedWalletId.value ?? user.value?.lastSelectedWalletId)

  if (walletId) {
    return wallets.value.find(wallet => wallet.id === walletId)
  }

  return fundWallets.value[0]
})

const isFiat = computed(() => {
  return activeWallet.value.currency.type === "fiat"
})

export function useUserService() {
  function setUser(userAccount: IUserAccount) {
    (userAccount?.wallets || []).forEach((wallet) => {
      wallet.currency = currencies.value.find(c => c.id === wallet.currencyId)
    })
    user.value = userAccount
  }
  function isAuthenticated() {
    return !!user.value
  }

  function selectWallet(walletId) {
    selectedWalletId.value = walletId || null
  }

  return {
    isAuthenticated,
    setUser,
    selectWallet,
    activeWallet,
    wallets,
    fundWallets,
    isFiat,
    user,
  }
}
